import { XIcon } from '@phosphor-icons/react';

// The kiosk's standard fullscreen-modal close button — extracted from the
// music browser modal so every kiosk overlay (music, security map, …) shares
// the same X.
export function ModalCloseButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Close"
      className="shrink-0 grid place-items-center w-12 h-12 rounded-full bg-elevated border border-border text-fg transition-transform active:scale-[0.94]"
    >
      <XIcon size={22} weight="bold" />
    </button>
  );
}
